import React from 'react'
import { Route, Switch, Redirect as RedirectAddress } from "react-router-dom";
import Redirect from '../Routes/Redirect'
import CommentSearch from '../Routes/CommentSearch'
// import SignIn from '../Routes/SignIn'
import Search from "../Routes/Search"
import Channel from '../Routes/Channel'
import MyInfo from '../Routes/MyInfo'
import Kind from '../Routes/Kind'
import DetailCategory from '../Routes/DetailCategory'

const LoggedInRoutes = () => (
  <Switch>
    <Route exact path="/" component={CommentSearch} />
    {/* <Route path="/signin" component={SignIn} /> */}
    <Route path="/search" component={Search} />
    <Route path="/redirect" component={Redirect} />
    <Route path="/myinfo" component={MyInfo} />
    <Route path="/qna/:channelId" component={Kind} />
    <Route path="/:channelId/:categoryId" component={DetailCategory} />
    <Route path="/:channelId" component={Channel} />
    <RedirectAddress from="*" to="/" />
  </Switch>
);


const LoggedOutRoutes = () => (
  <Switch>
    <Route exact path="/" component={CommentSearch} />
    {/* <Route path="/signin" component={SignIn} /> */}
    <Route path="/search" component={Search} />
    <Route path="/redirect" component={Redirect} />
    <Route path="/qna/:channelId" component={Kind} />
    <Route path="/:channelId/:categoryId" component={DetailCategory} />
    <Route path="/:channelId" component={Channel} />
    <RedirectAddress from="*" to="/" />
  </Switch>
);


const AppRouter = ({ isLoggedIn }) => {
  return (
    isLoggedIn ? <LoggedInRoutes /> : <LoggedOutRoutes />
  )
}


// AppRouter.propTypes = {
//   isLoggedIn: PropTypes.bool.isRequired,
// }


export default AppRouter;